import { render, staticRenderFns } from "./VotingTerminalState.vue?vue&type=template&id=5152284d&scoped=true"
import script from "./VotingTerminalState.vue?vue&type=script&lang=js"
export * from "./VotingTerminalState.vue?vue&type=script&lang=js"
import style0 from "./VotingTerminalState.vue?vue&type=style&index=0&id=5152284d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5152284d",
  null
  
)

export default component.exports